<div class="story-v3-banner container">
  <app-urgent-banner *ngIf="!config?.isSipStory && !config?.isFundraiserEnded" [endDate]="config?.fundraiser?.end_date" [config]="config"></app-urgent-banner>
  <div class="banner">
    <div *ngIf="config?.fundraiser?.beneficiary?.tax_benefit" class="tax_exempt"  matTooltip="80G Tax Exemption Certificate Available" matTooltipPosition="right" #tooltip="matTooltip" (click)="tooltip.toggle()">
      <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax Benefit Ribbon" src="/assets/images/transparent.png">
    </div>
    <img class="d-md-none d-none d-md-block banner-img" [attr.data-src]="config?.fundraiser?.theater?.cdn_path || config?.fundraiser?.leaderboard?.cdn_path" default="/assets/images/default-campaign-picture.jpg" alt="" />
    <img class="d-md-none banner-img" [attr.data-src]="config?.fundraiser?.leaderboard?.cdn_path" default="/assets/images/default-campaign-picture.jpg" alt="" />
    <div class="ketto-assured">
      <app-ketto-assured-v2 theme="theme_v5"></app-ketto-assured-v2>
    </div>
  </div>
</div>
